import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2949F1',
    },
    secondary: {
      main: '#46D090',
      light: '#F5EBFF',
      contrastText: '#47008F',
    },
    black: {
      main: '#000000',
    },
    background: {
      default: '#F5F5F5',
    },
    text: {
      primary: '#000000',
      secondary: '#5C5C5C',
    },
    red: {
      main: '#D04646',
    },
    roles: {
      participant: '#000000',
      patronlight: '#46D090',
      patron: '#2949F1',
      admin: '#D04646',
      inactive: '#D046C7'
    }
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiLinearProgress: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#e0e0e0',
        },
        barColorPrimary: {
          backgroundColor: '#000000',
        },
        root: {
          borderRadius: '25px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '25px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderTopLeftRadius: '25px',
          borderTopRightRadius: '25px',
          borderBottomLeftRadius: '25px',
          borderBottomRightRadius: '25px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderTopLeftRadius: '25px',
          borderTopRightRadius: '25px',
          borderBottomLeftRadius: '25px',
          borderBottomRightRadius: '25px',
          textTransform: 'none',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderTopLeftRadius: '25px',
          borderTopRightRadius: '25px',
          borderBottomLeftRadius: '25px',
          borderBottomRightRadius: '25px',
          '&.tss-1nm7mzi-MUIDataTableToolbarSelect-root': {
            minHeight: '64px',
            paddingTop: '0px',
            paddingBottom: '0px'
          },
        },
      },
    },
    MUIDataTable: {
      styleOverrides: {
        root: {
          '&&': {
            borderTopLeftRadius: '0px',
            borderTopRightRadius: '0px',
            borderBottomLeftRadius: '25px',
            borderBottomRightRadius: '25px',
            overflow: 'visible',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          color: '#000000'
        },
        deleteIcon: {
          color: "#5C5C5C",
        },

      }
    },
    MUIDataTableBodyCell: {
      styleOverrides: {
        root: {
          '&&': {
            padding: '5px 5px'
          },
        },
      },
    },
    MUIDataTableBodyRow: {
      styleOverrides: {
        root: {
          '&&': {
            height: '10px'
          },
        },
      },
    },    
    MuiTableCell: {
      styleOverrides: {        
        footer: {
          borderBottom: 'none',
        },        
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid rgba(224, 224, 224, 1)',
        },
      },
    },
    MuiSpeedDialAction: {
      styleOverrides: {
        staticTooltipLabel: {
          whiteSpace: "nowrap",
          maxWidth: "none"
        }
      }
    }
  }
});

export default theme;